function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#sync_icon_square_svg__clip0)",
  fill: "#2196F3"
}, /*#__PURE__*/React.createElement("path", {
  d: "M41.73.159a1.69 1.69 0 00-.973 1.529V6.75H7.007C3.286 6.75.259 9.78.259 13.5v21.815l6.75-5.626V13.5h33.75v5.063c0 .655.377 1.249.971 1.53a1.683 1.683 0 001.796-.234l10.124-8.437c.388-.32.608-.793.608-1.296s-.22-.975-.608-1.296L43.525.392a1.683 1.683 0 00-1.796-.233zM47.5 40.5H13.753v-5.063a1.69 1.69 0 00-.972-1.529 1.683 1.683 0 00-1.796.233L.86 42.58c-.389.32-.608.793-.608 1.296 0 .502.22.975.608 1.295l10.124 8.438c.503.422 1.202.51 1.796.233a1.69 1.69 0 00.972-1.53V47.25H47.5a6.757 6.757 0 006.75-6.75V18.685L47.5 24.31V40.5z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "sync_icon_square_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.251)",
  d: "M0 0h54v54H0z"
})));

function SvgSyncIconSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgSyncIconSquare;